module.exports = __webpack_public_path__ + "img/happyneuron.ea82910e.webp";